import { PortalError } from './PortalError';

export class EmptyIdError extends PortalError {
  constructor() {
    super('EmptyIdError', `Id not found in object`);
  }
}
